import { Popover2 } from '@blueprintjs/popover2'
import React from 'react'
import PulsatingDot from '../../../onboarding/Pulsating/PulsatingDot'
import firebase from 'firebase/app';
import SelectVProp2 from './SelectVProp2';



function SelectVprop({
    valueIndex,
    selectedVprop,
    FBvalueProp,
    setShowProfileVpropAdd,
    onboarded,
    auth
}) { 

    const clickedDone = () =>{
        firebase
        .firestore()
        .collection('onboards')
        .doc(auth.uid)
        .update({
            // onboarded: "yes",
            vPropShown: "yes"
        })
    }

    return (
        <div className="mt-4 ml-auto mr-3">
        {FBvalueProp?.length > 0 ?
        <SelectVProp2 
        FBvalueProp={FBvalueProp}
        valueIndex={valueIndex}
        selectedVprop={selectedVprop}
        />
        // <select 
        //     className="border-2 border-blue-500 p-1 rounded focus:outline-none"
        //     // defaultValue="default"
        //     value={valueIndex}
        //     onChange={(e) => selectedVprop(e)}
        //     // defaultValue={valueIndex}
        // >
        //     <option value='default' disabled>Choose a value prop...</option>
        //     {FBvalueProp !== '' ? FBvalueProp.map((vprop, index) =>{
        //         return(
        //             <option value={index} key={index}>
        //                 {vprop.Title} 
        //             </option>
        //                 )
        //         })
        //         :
        //         null
        //     }
        // </select>
        :
        <div>
            <button
            className="m-0 font-semibold px-2 py-1 rounded-lg bg-green-500 hover:bg-green-200 text-white"
            onClick={() => setShowProfileVpropAdd(true)}
            >
                + Add A Value Prop
            </button>
        </div>
        }
        {onboarded?.[0]?.vPropShown === 'no' ?
        <Popover2
        content={
            <div className="p-4 w-72">
                <div className="text-lg font-semibold">
                    Tell Bound About Your Company
                </div>
                <div className="my-2">
                    Choose a value proposition that you've created here so Bound can write personal messages for you.
                </div>
                <div className="mt-2 ml-auto">
                    <button 
                        className="bg-red-600 hover:bg-red-500 text-white rounded-lg py-0.5 px-2 font-semibold"
                        onClick={clickedDone}
                    >
                        Got It
                    </button>
                </div>
            </div>
        }
        interactionKind="hover"
        placement="right"
        >
            <div className="-ml-2 -mt-6">
            <PulsatingDot />
            </div>
        </Popover2>
        :
        null
        }
    </div>
    )
}

export default SelectVprop
